<template>
  <section id="contact" class="contact">
    <div class="contact-content">
      <!-- タイトル・サブタイトル -->
      <div class="text-content">
        <div class="title">{{ $t('page.contact.title') }}</div>
        <div class="sub-title">
            {{ $t('page.contact.sub-title') }}
        </div>
      </div>

      <!-- メインコンテンツ -->
      <div class="main-content">
        <div class="announcement-text" v-html="$t('page.contact.announcement')"></div>
        <div class="button-content">
          <!-- 問い合わせフォームへ -->
          <div class="form-button-content">
            <button
            class="contact-us-form-button form-button"
            @click="transitionContact"
            >
              <div class="svg svg-icon"></div>
              <div class="text">{{ $t('page.contact.us-form') }}</div>
            </button>
            <div class="form-time">
              <div class="form-time-label">{{ $t('page.contact.form-time-label') }}</div>
              <div class="form-time-detail">{{ $t('page.contact.form-time-detail') }}</div>
            </div>
          </div>
          <!-- 電話 -->
          <div class="call-button-content">
            <a
              v-if="isSP"
              class="inquiry-contact-address-button call-button"
              :href="`tel:${$t('util.telephone_address')}`"
            >
              <div class="svg svg-icon"></div>
              <div class="text">
                {{ $t('page.contact.inquiry-address') }}
              </div>
            </a>
            <div v-else class="inquiry-contact-address-button call-button">
              <div class="svg svg-icon"></div>
              <div class="text">
                {{ $t('page.contact.inquiry-address') }}
              </div>
            </div>
            <div class="call-time">
              <div class="call-time-label">{{ $t('page.contact.call-time-label') }}</div>
              <div class="call-time-detail">{{ $t('page.contact.call-time-detail') }}</div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </section>
</template>
<script setup lang="ts">
import { useMounted, useWindowSize } from "@vueuse/core";
import { actionTransition, transitionType } from '~~/src/models/Utility'

const localePath = useLocalePath()
const transitionContact = () => {
  actionTransition(localePath(transitionType.ContactPage))
}


const isMounted = useMounted()
// SP表示かどうか
const { width } = useWindowSize()
const isSP = computed(() => {
  if (!isMounted.value) return true
  return width.value <= 767
});
</script>
<style lang="scss" scoped>
@use '@/assets/styles/mixins' as m;
@use '@/assets/styles/variables' as v;
@use '@/assets/styles/util' as u;

#contact {
  position: relative;
  text-align: center;
}

.contact-content {
  background: v.$bg-white-color;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 168px 0 169px;
  @include m.sp() {
    padding: 64px 0;
  }

  .text-content {
    .title {
      color: v.$accent-color;
      font-size: 1.125rem;
      font-family: v.$accent-font-family;
      font-weight: v.$font-weight-light;
      margin: 0;
      @include m.sp() {
        font-size: 1rem;
        letter-spacing: 6.4px;
      }
    }

    .sub-title {
      color: v.$text-title-color;
      font-size: 1.375rem;
      @include m.sp() {
        font-size: 1.25rem;
        letter-spacing: 3px;
      }
    }
  }

  .main-content {
    margin: 0 auto;
    max-width: 912px;
    width: 100%;
    text-align: -webkit-center;

    .announcement-text {
      max-width: 640px;
      margin: 64px 0 90px;
      @include m.sp() {
        white-space: nowrap;
        width: calc(100% - 32px);
        font-size: 0.875rem;
        margin: 55px 16px 32px;
      }
    }

    .button-content {
      display: flex;
      justify-content: center;
      max-width: calc(912px + 6%);
      padding: 0 3%;
      gap: 32px;
      @include m.sp() {
        flex-wrap: wrap;
      }

      .form-button-content, .call-button-content {
        width: 100%;
      }

      .form-button {
        transition: all 0.3s ease-out;
      }
      .form-button, .call-button {
        padding: 20px 0;
        margin-top: 2%;
        width: 100%;
        display: flex;
        border: 1px solid v.$common-element-color;
        align-items: center;
        justify-content: center;
        line-height: 1.75;
        @include m.sp() {
          width: 94%;
          max-width: 343px;
        }

        .text {
          text-align: center;
          font-size: 1.125rem;
          white-space: nowrap;
          color: v.$text-base-color;
          @include m.sp() {
            font-size: 1rem;
            letter-spacing: 2.4px;
          }
        }
        .svg {
          width: 20px;
          height: 28px;
          @include m.sp() {
            width: 18px;
          }

          mask-size: contain;
          mask-repeat: no-repeat;
          mask-position: center;
          background-color: v.$common-element-color;
        }
      }

      .form-button:hover {
        background: v.$accent-color;
        border: 1px solid v.$accent-color;

        .text {
          color: v.$text-white-color;
        }
        .svg {
          background-color: v.$bg-white-color;
        }
      }
      .contact-us-form-button {
        .svg-icon {
          margin-right: 32px;
          mask-image: url(~/assets/pages/common/IconContact.svg);
          @include m.sp() {
            margin-right: 16px;
          }
        }
      }
      .inquiry-contact-address-button {
        .svg-icon {
          margin-right: 32px;
          mask-image: url(~/assets/pages/common/IconTelephone.svg);
          @include m.sp() {
            margin-right: 16px;
          }
        }
      }
      .form-time {
        @include u.localize-text;
        padding-top: 2%;
        text-align: center;
        line-height: 2;
        .form-time-label {
          font-size: 1.125rem;
          @include m.sp() {
            font-size: 1rem;
          }
        }
        .form-time-detail {
          font-size: 0.875rem;
          @include m.sp() {
            font-size: 0.8125rem;;
            margin: 8px auto 32px;
          }
        }
      }
      .call-time {
        @include u.localize-text;
        padding-top: 2%;
        text-align: center;
        line-height: 2;
        .call-time-label {
          font-size: 1.125rem;
          @include m.sp() {
            font-size: 1rem;
          }
        }
        .call-time-detail {
          font-size: 0.875rem;
          @include m.sp() {
            font-size: 0.8125rem;;
            margin: 8px auto;
          }
        }
      }
    }
  }
}
</style>
